<template>
    <div>
        <!-- mensajes de confirmacion -->
        <mensajeSistema></mensajeSistema>
        <v-tabs v-model="tab" dark class="rounded-lg" background-color="primary" active-class="tab-active"
            slider-color="#ffbc00">
            <v-tab class="font-weight-black">Gestionar Evaluación</v-tab>
            <v-tab class="font-weight-black">Registro Auxiliar</v-tab>
            <v-tab class="font-weight-black">Registro Oficial</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
            <v-tab-item class="py-2">
                <evaluacion></evaluacion>
            </v-tab-item>
            <v-tab-item class="py-2">
                <registroAuxiliar></registroAuxiliar>
            </v-tab-item>

            <v-tab-item class="py-2">
                <registroOficial></registroOficial>
            </v-tab-item>
        </v-tabs-items>
    </div>
</template>

<script>

import { mapMutations, mapGetters, mapActions } from 'vuex';

import GestionarEvaluacion from './progEvaluacion/gestionEvaluacion.vue'
import RegistroAuxiliar from './RegistroAuxiliar/RegistroAuxiliar.vue'
import RegistroOficial from './RegistroOficial/RegistroOficial.vue'


export default {
    name: 'Evaluacion',

    components: {
        evaluacion: GestionarEvaluacion,
        registroAuxiliar: RegistroAuxiliar,
        registroOficial: RegistroOficial
    },

    data: () => ({
        //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
        tab: 0,
        paramComponente: { "id_modulo": 8, 'id_submodulo': 96 }, //sud_modulo y modulo
        datoLogin: sessionStorage, // variables de sesion del usuario
        test: false,

    }),
    //computadas
    computed: {
        ...mapGetters('login', ['componenteEvento'])
    },
    created() {
        this.actualizarParamentro()
    },
    methods: {
        ...mapActions('login', ['parametroComponente']),
        actualizarParamentro() {
            this.parametroComponente(this.paramComponente)
        },

        //  ------- MENSAJE DE SISTEMA  --------
        ...mapMutations('mensajeSis', ['setEnviarMens']),
        ////////////////////////////////////////////////////////

     

    },

}
</script>